'use strict';

// https://262.ecma-international.org/6.0/#sec-toobject

module.exports = require('es-object-atoms/ToObject');



//////////////////
// WEBPACK FOOTER
// ./~/es-abstract/2021/ToObject.js
// module id = qvkp
// module chunks = 78